import { X, Printer, Hourglass } from "lucide-react";
import { brl, fmtTime } from "@/lib/api";
import { cardCls, Chip } from "@/components/mobile/parts";
import { cn } from "@/lib/utils";

function ItemLine({ i, open, waiting, onCancel }) {
  const off = i.status === "cancelled";
  return (
    <li className={cn("flex items-start gap-2 px-3 py-2.5 text-sm", off && "opacity-50")} data-testid={`m-order-item-${i.id}`}>
      <span className="w-8 shrink-0 font-mono font-bold text-[#1565c0]">{i.qty}x</span>
      <div className="min-w-0 flex-1">
        <p className={cn("font-medium", off && "line-through")}>{i.name}</p>
        {i.notes && <p className="text-xs text-amber-700">{i.notes}</p>}
        {off && <p className="text-xs text-slate-500">cancelado{i.cancel_reason ? `: ${i.cancel_reason}` : ""}</p>}
        {i.paid && <Chip tone="green">Pago</Chip>}
        {waiting && <Chip tone="amber"><Hourglass className="h-3 w-3" />Aguardando gerente</Chip>}
      </div>
      <span className="font-mono">{brl(i.total)}</span>
      {open && !off && !i.paid && !waiting && (
        <button onClick={() => onCancel(i)} className="grid h-8 w-8 place-items-center rounded-full text-slate-400 hover:bg-red-50 hover:text-red-500" aria-label={`Cancelar ${i.name}`} data-testid={`m-cancel-item-${i.id}`}><X className="h-4 w-4" /></button>
      )}
    </li>
  );
}

export function OrderGroupCard({ g, open, waitIds, onCancelItem, onCancelOrder, onReprint }) {
  const o = g.order;
  const cancellable = g.items.some((i) => i.status !== "cancelled" && !i.paid);
  const total = g.items.filter((i) => i.status !== "cancelled").reduce((s, i) => s + i.total, 0);
  return (
    <section className={cn(cardCls, "overflow-hidden")} data-testid={`m-order-group-${o?.number || "outros"}`}>
      <div className="flex items-center gap-2 bg-[#e3f2fd] px-3 py-2 text-xs text-[#0d47a1]">
        <span className="flex-1 font-semibold">{o ? `Pedido ${o.number} · ${fmtTime(o.at)} · ${o.user}` : "Itens do cardápio digital / anteriores"}</span>
        {o?.pickup_number && <Chip tone="blue">Senha {String(o.pickup_number).padStart(3, "0")}</Chip>}
        {o && <button onClick={() => onReprint(g)} className="grid h-7 w-7 place-items-center rounded-full hover:bg-white" aria-label="Reimprimir pedido" data-testid={`m-reprint-group-${o.number}`}><Printer className="h-4 w-4" /></button>}
      </div>
      <ul className="divide-y divide-slate-100">
        {g.items.map((i) => <ItemLine key={i.id} i={i} open={open} waiting={waitIds.has(i.id)} onCancel={onCancelItem} />)}
      </ul>
      <div className="flex items-center justify-between border-t border-slate-100 px-3 py-2 text-sm">
        {o && open && cancellable && !waitIds.has(o.id)
          ? <button onClick={() => onCancelOrder(g)} className="text-xs font-semibold text-red-600" data-testid={`m-cancel-order-${o.number}`}>Cancelar pedido</button>
          : <span className="text-xs text-slate-400">{o && waitIds.has(o.id) ? "Cancelamento aguardando gerente" : ""}</span>}
        <span className="font-mono font-bold">{brl(total)}</span>
      </div>
    </section>
  );
}
